import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DelegationReportsService } from 'src/app/_services/ApplicationServices/delegation-reports.service';
import { DelegationReportdata, RecentDelegatee } from 'src/app/_services/ApplicationServices/delegation-reports';
import { JsonPipe, Location } from '@angular/common';
import { DelegationReportFiltersdata } from 'src/app/_services/ApplicationServices/delegation-report-filter';
import { MessageService, SortEvent } from 'primeng/api'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
//import { PageEvent } from '@angular/material/paginator';
import { ExcelService } from 'src/app/_services/CommonServices/excel.service';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SAPID } from 'src/app/_shared/common/global-variables';
import { QuickDeligationService } from 'src/app/_services/ApplicationServices/quick-delegation.service';

@Component({
    selector: 'app-delegation-reports',
    templateUrl: './delegation-reports.component.html',
    styleUrls: ['./delegation-reports.component.css'],
    standalone: false
})
export class DelegationReportsComponent implements OnInit {

  first = 0;
  rows = 10;

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  pageChange(event) {
    this.first = event.first;
    this.rows = event.rows;
  }
  // isLastPage(): boolean {
  //   return this.customers ? this.first === this.customers.length - this.rows : true;
  // }

  // isFirstPage(): boolean {
  //   return this.customers ? this.first === 0 : true;
  // }
  isLastPage(): boolean {
    return this.delegationData ? this.first === this.delegationData.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.delegationData ? this.first === 0 : true;
  }


  //visibleSidebar2;

  // Dropdwon
  option1
  constructor(private global: GlobalService, private delegationReportsService: DelegationReportsService,
    private _location: Location,private advancedDelService: QuickDeligationService, private messageService: MessageService, private modalService: BsModalService, private excelService: ExcelService, private SpinnerService: NgxSpinnerService) {
    this.option1 = [
      { label: 'Select', value: null },
      { label: 'Option 1', value: { id: 1, name: 'Option1', code: 'O1' } },
      { label: 'Option 2', value: { id: 2, name: 'Option2', code: 'O4' } },
      { label: 'Option 3', value: { id: 3, name: 'Option3', code: 'O3' } },
      { label: 'Option 4', value: { id: 4, name: 'Option4', code: 'O4' } },
      { label: 'Option 5', value: { id: 5, name: 'Option5', code: 'O5' } }
    ];
  }

  visibleSidebar2: boolean;
  private errorMessage: string;

  delegationData: DelegationReportdata[];

  recentDelegatee: RecentDelegatee[];
  startdate: number;
  enddate: number;
  fileName = 'Delegation Report.xlsx';

  applicationfilterddldata: DelegationReportFiltersdata[];
  rolesfilterddldata: DelegationReportFiltersdata[];
  statusfilterddldata: DelegationReportFiltersdata[];
  brands: string[] = [''];
  filteredBrands: any[];
  delegateeSapId: string = null;
  flightDate: string;
  delegateeTextvalue: string = '';
  requestIdTextValue: string = null;
  DelegationStartDate: string = null;
  DelegationEndDatetime: string = null;
  appIdValue: number = 0;
  roleIdValue: number = 0;
  statusIdValue: number = 0;
  localsapid: string = null;
  exporttoexceldisable: boolean = true;
  AppsFilter;
  StatusFilter;
  RolesFilter;
  _appFilterData: string = null;
  _status: string = null;
  _roleName: string = null;
  EntriesCount: number;
  delegationDataTbl: any[] = [];
  showPagination: boolean = true;
  modalRef: BsModalRef;
  // Alert 
  alertIcon = "assets/images/alert-01.svg";
  alert(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'alertM' })
    );
  }

  @ViewChild('downloadExcel') downloadAlert: TemplateRef<any>;
  @ViewChild('alertfilter') filterAlert: TemplateRef<any>;

  public get AppFilterData(): string {
    return this._appFilterData;
  }
  public set AppFilterData(value: string) {
    this._appFilterData = value;
  }

  public get RequestStatus(): string {
    return this._status;
  }
  public set RequestStatus(value: string) {
    this._status = value;
  }
  public get RoleNameValue(): string {
    return this._roleName;
  }
  public set RoleNameValue(value: string) {
    this._roleName = value;
  }

  ngOnInit() {
    //this.customerService.getCustomersLarge().then((customers) => (this.customers = customers));
    this.SpinnerService.show();
    this.visibleSidebar2 = true;
    this.getfiltersddldata();   
  }
  getfiltersddldata() {
    this.delegationReportsService.getApplicationFilterData().subscribe(
      data => {
        this.applicationfilterddldata = data;
 
        var applicationsfilter = [];
        applicationsfilter = [{ label: 'Select', value: null }];
        data.forEach((element, i) => {
          applicationsfilter.push({ label: element.ApplicationDescription, value: element.AppId })
        })
        this.AppsFilter = applicationsfilter;
        this.SpinnerService.hide();
      },
      err => this.errorMessage = err
    );

    this.delegationReportsService.getStatusFilterData().subscribe(
      data => {
        this.statusfilterddldata = data;

        var statusFilter = [];
        statusFilter = [{ label: 'Select', value: null }];
        data.forEach((element, i) => {
          statusFilter.push({ label: element.StatusDescription, value: element.StatusId })
        })
        this.StatusFilter = statusFilter;
        this.SpinnerService.hide();
      },
      err => this.errorMessage = err
    );


  }


  getRolebyApplication() {
    let AppId = Number(this.AppFilterData)
    this.delegationReportsService.getCDSRolesFilterData(AppId).subscribe(
      data => {
        this.rolesfilterddldata = data;
        var rolesFilter = [];
        rolesFilter = [{ label: 'Select', value: null }];
        data.forEach((element, i) => {
          rolesFilter.push({ label: element.RoleName, value: element.RoleId })
        })
        this.RolesFilter = rolesFilter;
      },
      err => this.errorMessage = err
    );
  }

  getDataofFiltersValues() {
   
    this.localsapid = this.global.UserLoggedInSAPID;
    if (this.delegateeTextvalue == null || this.delegateeTextvalue == '') {
      this.delegateeSapId = null;
    }
    const filterdata = <DelegationReportdata>{
      AppId: Number(this.AppFilterData),
      RoleId: Number(this.AppFilterData == '' ? '' : this.RoleNameValue),
      StatusId: Number(this.RequestStatus),
      DelegateeSAPId: this.delegateeSapId,
      LoggedInSapId: this.localsapid
    }
    if (filterdata.AppId == 0 && filterdata.RoleId == 0 && filterdata.StatusId == 0 && (this.delegateeTextvalue == null || this.delegateeTextvalue == '')) {
      alert('Please enter/select value in any filter option');
      //this.alert(this.filterAlert);
      return false;
    }
    this.visibleSidebar2 = true;
 

    this.delegationReportsService.getDelegationRequestdata(filterdata).subscribe(
      data => {
      
        this.delegationData = data;
        if (data.length != 0) {
          this.exporttoexceldisable = false;
        }
        else {
          this.exporttoexceldisable = true;
        }
        this.visibleSidebar2 = false;
      },
      err => this.errorMessage = err
    )
  }
  updateDelegateeId(event) {
    if (event !== "" && this.delegateeTextvalue !== "") {
      //this.delegateeSapId = event.toString().substring(event.toString().length - 9, event.toString().length - 1);
      this.delegateeSapId = event.value.match(/\(([^)]+)\)/)[1];
    }
    else {
      this.delegateeSapId = "";
    }
  }
  textValue(event) {
    if (this.delegateeTextvalue.length > 4) {
      this.delegationReportsService.fetchEmployeeSuggestions(this.delegateeTextvalue).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;
          },
          error: err => this.errorMessage = err
        });
    }

    if (this.delegateeTextvalue.length > 4) {
      const sapId = <SAPID>
        {
          ReqSAPID: this.delegateeTextvalue
        }
      this.advancedDelService.fetchDelegateeSuggestions(sapId).subscribe(
        {
          next: data => {
            this.recentDelegatee = data;
          },
          error: err => this.errorMessage = err
        });
      this.SelectedBrands();
    }
  }

  
  SelectedBrands() {
    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      let brand = this.brands[i];

      this.filteredBrands.push(brand);

    }
  }
  
  bindRecentDelegatee() {
    for (let i = 0; i < this.recentDelegatee?.length; i++) {
      this.brands[i] = this.recentDelegatee[i].EmpName + '(' + this.recentDelegatee[i].SAPID + ')';
    }
  }

  filterBrands(event) {
    this.bindRecentDelegatee();
    this.filteredBrands = [];
    for (let i = 0; i < this.brands.length; i++) {
      let brand = this.brands[i];
      if (brand.toString().toLowerCase().indexOf(event.query.toString().toLowerCase()) !== -1) {
        this.filteredBrands.push(brand);
      }
    }
  }

  ClearData() {
    this.AppFilterData = null,
    this.RoleNameValue = null,
    this.RequestStatus = null,
    this.delegateeTextvalue = null
  }

  customSort(event: SortEvent) {
    event.data.sort((a, b) => {
      let value1 = a[event.field];
      let value2 = b[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }

  exporttoexcel(): void {
    const obj = <DelegationReportdata>{
      AppId: Number(this.AppFilterData),
      RoleId: Number(this.AppFilterData == '' ? '' : this.RoleNameValue),
      StatusId: Number(this.RequestStatus),
      DelegateeSAPId: this.delegateeSapId,
      LoggedInSapId: this.localsapid
    }
    this.delegationReportsService.downloadDelegationRequestdata(obj).subscribe(data => {
      this.delegationData = data;
     
      this.excelService.downloadExcelJs(data, 'Delegation Report');
    },
      //err=> this.errorMessage = err 
      (error: Response) => {
        if (error.status === 401)
          this.alert(this.downloadAlert);
 
      }
    )
  }



}
